import { render, staticRenderFns } from "./LocationMappingModal.vue?vue&type=template&id=65131054"
import script from "./LocationMappingModal.vue?vue&type=script&lang=js"
export * from "./LocationMappingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports